module.exports = __webpack_public_path__ + "static/media/baseballTonight.9b5b24bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/about/baseballTonight.jpg
// module id = 470
// module chunks = 0